// @flow
import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import InfoLabel, { InfoLabelModes } from 'UI/components/molecules/InfoLabel';

import { gridValues, useInfoLabelClasses } from './styles';

type InfoLabelsGridProps = {
  labels: Array<Object>,
  loading: boolean,
  isFlexibleGrid: boolean
};

const InfoLabelsGrid = ({ labels, loading, isFlexibleGrid }: InfoLabelsGridProps) => {
  const classes = useInfoLabelClasses();
  const fixedGrid = { ...gridValues };
  const normalizedLabels = Array.isArray(labels) ? labels : [];

  return (
    <Grid container spacing={3}>
      {normalizedLabels.map(items => {
        const itemsConfig = Array.isArray(items) ? items : [items];

        return itemsConfig.map(item => {
          if (!item) return null;

          const { visible = true } = item;

          const defaultLayoutProps = {
            ...fixedGrid,
            ...(item.config || {})
          };

          const shouldUseFixedClass = !isFlexibleGrid && !item.config;

          return visible ? (
            <React.Fragment key={`${item.title}-${item.description}`}>
              <Grid
                aria-label={`${item.title} container`}
                component="dl"
                item
                role="group"
                className={shouldUseFixedClass ? classes.infoLabel : undefined}
                {...defaultLayoutProps}
                {...item.config}
              >
                <InfoLabel
                  canCopy={item.mode === InfoLabelModes.EXTERNAL_LINK}
                  cropped={false}
                  isLoading={loading}
                  variant="body1"
                  {...item}
                />
              </Grid>
              {item.shouldAddDivider && <Divider />}
            </React.Fragment>
          ) : null;
        });
      })}
    </Grid>
  );
};

InfoLabelsGrid.defaultProps = {
  labels: [],
  loading: false,
  isFlexibleGrid: false
};

export default InfoLabelsGrid;
